import { SelectData } from "../../models";

export const LANDHOLDING_REFERENCE_TYPE_OPTIONS: SelectData = [
  { key: "Single Business Identifier", value: "Single Business Identifier" },
  { key: "Business Reference Number", value: "Business Reference Number" },
  { key: "DAERA Business ID", value: "DAERA Business ID" },
  { key: "Customer Reference Number", value: "Customer Reference Number" },
  { key: "Title Number", value: "Title Number" },
];
